import EmailTemplatesTable from '@/components/tables/EmailTemplatesTable';
import { Box } from '@mui/material';
import React from 'react';

const TemplateTableTab = () => {
    
	return (
		<>
			<EmailTemplatesTable />
		</>
	);
};
export default TemplateTableTab;